import styled from 'styled-components';

export const NotificationListFilter = styled.div`
  display: flex;
  align-items: center;
  input {
    margin-top: 3.5%;
  }
  button {
    background-color: white;
  }
`;
